
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import ErrorBoundary from './components/ErrorBoundary'
import Root from './components/Root'

ReactDOM.createRoot(document.getElementById('root')).render(
  <Root>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </Root>
)
